import script from "./MattersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MattersPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__